import React, { useState, memo, useEffect, useContext } from 'react'

// components
import { Box, Button, Divider, useTheme, useMediaQuery, Typography } from '@mui/material'

// redux
import { connect } from 'react-redux'
import setRedirectUrl from '../../redux/actions/redirection/setRedirectUrl'
import Navbar from '../../components/Navbar'
import ToolbarHome from './components/Toolbar'
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined'
import Elementos from './components/Elementos'
import Anuncios from './components/Anuncios'
import { useAnuncios } from './hooks/anuncios.hook'
import useLocal from '../Products/hooks/locals.hook'
import { GetStatus } from '../AdminLocal/services/historias.service'
import CreateProduct from '../Products/widgets/CreateProduct'
import { useNavigate } from 'react-router'
import Footer from './components/Footer'
import { useMetricas } from './hooks/metricas.hook'
import SnackBarUtils from '../../utils/SnackBarUtils'
import { TenantsContext } from '../../context/tenants.context'
import useRubrosLocal from '../Products/hooks/rubros.hook'
import { HistoriasPublicadasAhora, StatusHistorias } from '../AdminLocal/types'
import DialogComprarHistorias from './components/botonesHistorias/comprarHistorias'
import CrearHistorias from './components/botonesHistorias/subirHistoria/subirHistorias'
import DialogVerHistorias from './components/botonesHistorias/verHistorias'
import { esLocalPendiente, tenantHabilitaContactoSoporte } from '../../components/Common/utils/contactoSoporte'
import DialogContactoSoporte from '../../components/Common/DialogContactoSoporte'
import setDialogoSoporteMostrado from '../../redux/actions/logged/setDialogSoporteMostrado'

const Home: React.FC = (props: any) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const { codLocal } = props.logged.userLogged
  const {
    local,
    retail,
    historiasBanner,
    historiasLink,
    maxPhotos,
    maxPublicaciones,
    esMinorista,
    precioDto,
    ofrecerPremium,
    usaSku,
    subeVideo,
    maxDurationVideo,
    maxSizeVideo
  } = useLocal(codLocal)
  const { rubros } = useRubrosLocal()
  const { anuncios, fetchData: fetchAnuncios, idBannerConfig } = useAnuncios(codLocal)
  const { fetchMetricas, metricas } = useMetricas(codLocal)
  const navigate = useNavigate()
  const [newProduct, setNewProduct] = useState<boolean>(false)
  const [estado, setEstado] = useState<StatusHistorias | null>(null)
  const { tenant } = useContext(TenantsContext)
  const [openComprarHistorias, setOpenComprarHistorias] = useState<boolean>(false)
  const [crearHistoria, setCrearHistoria] = useState<boolean>(false)
  const [openVerHistorias, setOpenVerHistorias] = useState<boolean>(false)
  const [historias, setHistorias] = useState<HistoriasPublicadasAhora>(null)
  const [loadingVideo, setLoadingVideo] = useState<boolean>(false)
  const [openContactoSoporte, setOpenContactoSoporte] = useState<boolean>(false)

  useEffect(() => {
    if (!local || !tenant) return
    if (props.logged.userLogged.dialogoSoporteMostrado) return
    if (!tenantHabilitaContactoSoporte(tenant)) return
    if (!esLocalPendiente(local.statusFlags)) return
    setOpenContactoSoporte(true)
    props.setDialogoSoporteMostrado()
  }, [local, tenant])

  const updateEstado = async (codLocal: string) => {
    if (estado && historias) return
    try {
      await GetStatus(codLocal, tenant).then((res) => {
        setEstado(res.data.data)
        setHistorias(res.data.data?.historiasPublicadasAhora)
      })
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    !metricas && fetchMetricas(false)
    !anuncios && fetchAnuncios()
    !estado && updateEstado(codLocal)
  }, [codLocal])

  //if (!metricas || !anuncios) return <></>

  return (
    <>
      <Navbar title={`Hola ${local?.nombre || ''}!`} />
      {anuncios && <Anuncios anuncios={anuncios} isMobile={isMobile} idBannerConfig={idBannerConfig} />}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#F5F5F5',
          marginBottom: isMobile ? '70px' : '20px',
          ...(isMobile && { borderRadius: '20px' })
        }}
      >
        <ToolbarHome isMobile={isMobile} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            width: isMobile ? '100%' : '60%',
            margin: '0 auto',
            gap: isMobile ? '10px' : '20px',
            marginTop: isMobile ? '50px' : '20px',
            marginBottom: isMobile ? '0px' : '20px',
            ...(isMobile && { paddingRight: '10px', paddingLeft: '10px' })
          }}
        >
          <Button
            variant="contained"
            size="large"
            sx={{
              gap: isMobile ? '10px' : '20px',
              padding: isMobile ? '6px 10px' : '20px 50px',
              width: '50%',
              borderRadius: '15px',
              flexDirection: isMobile ? 'column' : 'row',
              border: '2px solid',
              backgroundColor: '#5983EF',
              '&:hover': {
                backgroundColor: '#1346C7'
              },
              boxShadow: '0px 4px 4px 0px #00000040'
            }}
            disabled={loadingVideo}
            onClick={() => {
              if (metricas?.cantOfertasDisp <= 0 && !ofrecerPremium) {
                SnackBarUtils.info(`Alcanzaste el límite de ${maxPublicaciones} publicaciones`)
              } else {
                setNewProduct(true)
              }
            }}
          >
            <AddBoxOutlinedIcon fontSize="large" />
            <Typography
              style={{
                fontWeight: 800,
                textAlign: isMobile ? 'center' : 'start',
                fontSize: isMobile ? '16px' : '20px',
                fontFamily: 'Plus Jakarta Sans',
                lineHeight: isMobile ? '20.16px' : '25.2px'
              }}
            >
              Publicar nuevo producto
            </Typography>
          </Button>
          <Button
            variant="outlined"
            size="large"
            sx={{
              gap: isMobile ? '10px' : '20px',
              padding: isMobile ? '6px 10px' : '20px 50px',
              width: '50%',
              borderRadius: '15px',
              flexDirection: isMobile ? 'column' : 'row',
              color: '#5983EF',
              border: '2px solid',
              backgroundColor: '#FFFFFF',
              '&:hover': {
                backgroundColor: '#E3EAFC'
              },
              boxShadow: '0px 4px 4px 0px #00000040'
            }}
            onClick={() => navigate('/abm-products')}
          >
            <RemoveRedEyeOutlinedIcon fontSize="large" />
            <Typography
              style={{
                fontWeight: 800,
                textAlign: isMobile ? 'center' : 'start',
                fontSize: isMobile ? '16px' : '20px',
                fontFamily: 'Plus Jakarta Sans',
                lineHeight: isMobile ? '20.16px' : '25.2px'
              }}
            >
              Ver mis publicaciones
            </Typography>
          </Button>
        </Box>
        {!isMobile && <Divider sx={{ width: '70%', margin: '0 auto' }} />}
        {metricas && estado && (
          <Elementos
            isMobile={isMobile}
            metricas={metricas}
            estado={estado}
            setOpenComprarHistorias={setOpenComprarHistorias}
            setOpenVerHistorias={setOpenVerHistorias}
            setCrearHistoria={setCrearHistoria}
          />
        )}
      </Box>
      {metricas && estado && <Footer />}
      <CreateProduct
        local={local}
        admin={false}
        open={newProduct}
        setOpen={setNewProduct}
        precioDto={precioDto}
        retailer={retail}
        //wholesaler={wholesaler}
        rubros={rubros}
        maxPhotos={maxPhotos}
        codLocal={codLocal}
        esMinorista={esMinorista}
        cantOfertasDisp={metricas?.cantOfertasDisp}
        usaSku={usaSku}
        ofrecerPremium={ofrecerPremium}
        subeVideo={subeVideo}
        maxSizeVideo={maxSizeVideo}
        maxDurationVideo={maxDurationVideo}
        setLoadingVideo={setLoadingVideo}
      />
      <DialogComprarHistorias
        open={openComprarHistorias}
        setOpen={setOpenComprarHistorias}
        banner={historiasBanner}
        link={historiasLink}
      />
      {historias?.itemList && (
        <DialogVerHistorias
          open={openVerHistorias}
          setOpen={setOpenVerHistorias}
          historias={historias}
          isMobile={isMobile}
          codLocal={codLocal}
          crearHistoria={setCrearHistoria}
          updateHistorias={updateEstado}
        />
      )}
      <CrearHistorias
        open={crearHistoria}
        setOpen={setCrearHistoria}
        codLocal={codLocal}
        isMobile={isMobile}
        updateHistorias={updateEstado}
      />
      <DialogContactoSoporte
        open={openContactoSoporte}
        codLocal={codLocal}
        closable
        onClose={() => setOpenContactoSoporte(false)}
      />
    </>
  )
}

const mapStateToProps = (state: any) => {
  return {
    logged: state.logged,
    theme: state.theme,
    toaster: state.toaster,
    redirection: state.redirection
  }
}

const mapDispatchToProps = {
  // resetToaster,
  setRedirectUrl,
  setDialogoSoporteMostrado
}

export default connect(mapStateToProps, mapDispatchToProps)(memo(Home))
